import React, { Component } from 'react'
import { SmartDispatchLayout } from '../../../../src/styled/common-styled'
import { connect } from 'react-redux'
import {
  Row,
  Col,
  Divider,
  Input,
  Tooltip,
  Spin,
  Button,
  Icon,
  Dropdown,
  Menu,
  message,
} from 'antd'
import axios from 'axios'
import { renderToString } from 'react-dom/server'
import Breadcrumb from '../../../modules/shared/components/Breadcrumb'
import LangContext, { i18n } from 'modules/shared/context/langContext'
import { appendScript } from 'lib/useScript'
import LocationInfoMarkerLongdoMap from '../../shared/components/map-assets/Marker/LocationInfoMarkerLongdoMap'
import IconMyLocation from '../../shared/components/map-assets/Marker/IconMyLocation'
import {
  updateSmartDispatching,
  createSmartDispatching,
  getNearByLocationSmartDispatching,
} from '../actions'
import AuthorizeComponent from '../../auth/components/AuthorizeComponent'
import ModalConfirmPolygon from './ModalConfirmPolygon'
import { debounce } from 'debounce'
import NeighborhoodInformation from './NeighborhoodInformation'
import ModalEditDeleteRoute from './ModalEditAndDeleteRoute'
import SearchStartEndLocation from './SearchStartEndLocation'
import PopupMarkerSmartDispatching from './PopupMarkerSmartDispatching'
import ListNearestModal from './ListNearestModal'
import Notification from './Notification'
import IconMarkerSmartDispatching from './IconMarkerSmartDispatching'

const ButtonGroup = Button.Group

var map = null
var maps = null
var longdo = null
class Index extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isMenuMapTypeClick: '',
      loadScriptSuccess: false,
      isFireReq: false,
      data: {
        id: '',
        lat: '',
        lng: '',
        name: 'รถโม่เล็ก',
        geoFene: [],
      },
      map: null,
      longdo: null,
      Marker: [],
      Polygon: [],
      Circle: [],
      apiData: null,
      unload_point_show_Area: false,
      unload_point_circle: null,
      unload_point_show_POI: false,
      unload_point_area_Polyline: null,
      isMenuMapToolsCLick: '',
      geoFene: [],
      getIdPolygon: '',
      visible: false,
      cpac_condition: '',
      data_for_edit: [],
      keepMarker: [],
      editable: false,
      tempMarker: [],
      loading: false,
      keepPolygon: [],
      keepPolygonDoNoExist: [],
      keepCirclePolygon: [],
      keepMarkerLocation: [],
      keepPolygonLocation: [],
      getNextPropsRoute: null,
      updatebtn: false,
      keepEditPolygon: [],
      visibleSearchTooltip: false,
      isFireReq: false,
      suggest_place: '',
      suggestPlace: [],
      placeMarker: [],
      initialBoundBox: [
        {
          lat: 13.756261348904085,
          lng: 100.5286654829979,
        },
        {
          lat: 13.756261348904085,
          lng: 100.46806901693344,
        },
        {
          lat: 13.73445941145562,
          lng: 100.46806901693344,
        },
        {
          lat: 13.73445941145562,
          lng: 100.5286654829979,
        },
      ],
      showClear: false,
      newGeoFene: [],
      hideDraw: true,
      ListsRoute: [],
      showSearch: true,
      searchLatitudeLongitudeLongitude: '',
      getNote: '',
      objRoute: null,
      showPlantCpac: true,
      showRoute: true,
      showRouteDoNotEnter: true,
      showSiteSmallTruck: true,
      showSiteLargeTruck: true,
      objPlantCpacFilterBounds: [],
      objRouteFilterBounds: [],
      objRouteDoNotEnterFilterBounds: [],
      objSiteSmallTruckFilterBounds: [],
      objSiteLargeTruckFilterBounds: [],
      objPlantCpacNoFilterBounds: [],
      objRouteNoFilterBounds: [],
      objRouteDoNotEnterNoFilterBounds: [],
      objSiteSmallTruckNoFilterBounds: [],
      objSiteLargeTruckNoFilterBounds: [],
      siteLargeTruckMarker: [],
      siteSmallTruckMarker: [],
      plantCpacMarker: [],
      showComfirmSavePolygon: false,
      selectTools: '',
      previousPolyline: [],
      btnCarThisArea: false,
      showModalEditDeleteRoute: false,
      showSearchStartEndLocation: false,
      showListNearestModal: false,
      showNotification: false,
      nameRoute: '',
      overlayDropLat: '',
      overlayDropLng: '',
      nearByLocationList: [],
      routePolyline: null,
      start_marker: null,
      end_marker: null,
      my_location: null,
      editValue: '',
      allDataFromSearch: [],
      infoSearch: { location_code: '', location_name: '' },
      showNeighborhoodInformation: false,
      startPointLocationName: '',
      endPointLocationName: '',
      hideToggleWhenDraw: false,
    }
  }

  onChangeNameRoute = e => {
    this.setState({
      nameRoute: e.target.values,
    })
  }

  onChangeRemark = e => {
    this.setState({
      getNote: e.target.values,
    })
  }

  postLocationSmartDispatching = payload => {
    this.setState(
      {
        loading: true,
        hideDraw: false,
      },
      () => {
        axios({
          method: 'post',
          url: `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/small-truck-route/locations`,
          headers: { Authorization: `Bearer ${this.props.auth.accessToken}` },
          data: payload,
        }).then(response => {
          this.setState(
            {
              showSearchStartEndLocation:
                this.state.suggestPlace != '' ? true : false,

              showNeighborhoodInformation:
                this.state.suggest_place != '' ? true : false,
              //All data
              allDataFromSearch: response,
              //End All Data
              loading: false,
              //Cpac Plant
              objPlantCpacFilterBounds: response.data.plant.filter_bounds,
              objPlantCpacNoFilterBounds:
                response.data.big_truck_agency.no_filter_bounds,
              //End Cpac Plant

              //Route
              objRouteFilterBounds:
                response.data.small_truck_route.filter_bounds,
              objRouteDoNotEnterFilterBounds:
                response.data.no_small_truck_route.filter_bounds,
              objRouteNoFilterBounds:
                response.data.small_truck_route.no_filter_bounds,
              objRouteDoNotEnterNoFilterBounds:
                response.data.no_small_truck_route.no_filter_bounds,
              //End Route

              //SmallTruckRoute
              objSiteSmallTruckFilterBounds:
                response.data.small_truck_agency.filter_bounds,
              objSiteSmallTruckNoFilterBounds:
                response.data.small_truck_agency.no_filter_bounds,
              //End SmallSmallTruckRoute

              //LargeTruckRoute
              objSiteLargeTruckFilterBounds:
                response.data.big_truck_agency.filter_bounds,
              objSiteLargeTruckNoFilterBounds:
                response.data.big_truck_agency.no_filter_bounds,
              //EndTruckRoute
            },
            async () => {
              let mergeRoute = [
                ...this.state.objRouteFilterBounds,
                ...this.state.objRouteDoNotEnterFilterBounds,
                ...this.state.objRouteNoFilterBounds,
                ...this.state.objRouteDoNotEnterNoFilterBounds,
              ]
              this.setState({
                getNextPropsRoute: mergeRoute,
              })
              this.displayMarkerSiteSmallTruck(
                this.state.objSiteSmallTruckFilterBounds,
              )
              this.displayMarkerSiteLargeTruck(
                this.state.objSiteLargeTruckFilterBounds,
              )
              this.displayRoutePolygon(mergeRoute)
              //   this.displayRoutePolygon(
              //     this.state.objRouteDoNotEnterFilterBounds,
              //   )
              this.displayMarkerPlantCpac(this.state.objPlantCpacFilterBounds)
            },
          )
        })
      },
    )
  }

  handleGetdistanceList = (value, start, end) => {
    if (this.state.routePolyline != null) {
      map.Overlays.remove(this.state.routePolyline)
      this.setState({
        routePolyline: null,
      })
    }
    if (this.state.my_location != null) {
      map.Overlays.remove(this.state.my_location)
      this.setState({
        my_location: null,
      })
    }
    if (this.state.end_marker != null) {
      map.Overlays.remove(this.state.end_marker)
      this.setState({
        end_marker: null,
      })
    }
    if (this.state.start_marker != null) {
      map.Overlays.remove(this.state.start_marker)
      this.setState({
        start_marker: null,
      })
    }

    let self = this
    let features = []
    let distance = value.data.data.distance
    let interval = value.data.data.interval
    value.data.features.map(item => {
      item.geometry.coordinates.map(coordinatesItem => {
        features = [
          ...features,
          { lat: coordinatesItem[1], lng: coordinatesItem[0] },
        ]
      })
    })
    if (
      this.props.auth.profile.map_type === 'google' ||
      this.props.auth.profile.map_type === 'longdo'
    ) {
      let mapFeatures = features.map(f => ({
        lat: f.lat,
        lon: f.lng,
      }))
      let start_marker = new window.longdo.Marker(start, {
        icon: {
          html: renderToString(
            <IconMyLocation
              image="/img/Component 14 – 49.png"
              title={i18n[this.props.language].y.you}
            />,
          ),
          offset: { x: 12, y: 45 },
        },
        draggable: false,
      })

      let end_marker = new window.longdo.Marker(end, {
        icon: {
          html: renderToString(
            <IconMyLocation image="/img/Group 18442.png" title="" />,
          ),
          offset: { x: 12, y: 45 },
        },
        draggable: false,
      })

      let routePolyline = new longdo.Polyline(mapFeatures, {
        strokeOpacity: 0.7,
        strokeWeight: 5,
        lineColor: '#7C64EA',
      })

      self.setState({
        routePolyline: routePolyline,
        start_marker: start_marker,
        end_marker: end_marker,
        showSearchStartEndLocation: true,
        showNeighborhoodInformation: false,
        suggest_place: '',
        selectTools: 'directionRoute',
        hideDraw: true,
      })
      map.Overlays.add(routePolyline)
      map.Overlays.add(start_marker)
      map.Overlays.add(end_marker)

      if (longdo != null) {
        let latArry = []
        let lngArry = []

        for (let j = 0; j < features.length; j++) {
          latArry.push(parseFloat(features[j].lat))
          lngArry.push(parseFloat(features[j].lng))
        }

        let minLat = Math.min.apply(null, latArry)
        let maxLat = Math.max.apply(null, latArry)

        let minLon = Math.min.apply(null, lngArry)
        let maxLon = Math.max.apply(null, lngArry)

        let bound = { minLon, minLat, maxLon, maxLat }

        map.bound(bound)
      }
    }

    let hours = Math.floor(interval / 3600) // get hours
    let minutes = Math.floor((interval - hours * 3600) / 60) // get minutes

    if (hours < 10) hours = '0' + hours
    if (minutes < 10) minutes = '0' + minutes

    self.setState({
      distance: distance / 1000,
      intervalHours: hours,
      intervalMins: minutes,
    })
  }

  drawRouteNearBylocation = location => {
    let getItem = this.state.nearByLocationList.find(item => {
      return item.location_code == location.locationCode
    })
    this.setState({
      endPointLocationName: location.locationName,
    })
    axios({
      method: 'get',
      url: `https://cpac-ldbox.longdo.com/map/mmroute/json/route/guide?flon=${this.state.overlayDropLng}&flat=${this.state.overlayDropLat}&tlon=${getItem.lng}&tlat=${getItem.lat}&mode=driving&type=17&locale=th&key=${this.props.auth.profile.longdo_map_key}`,
    })
      .then((res) => {
        this.handleGetdistanceList(
          res,
          { lon: this.state.overlayDropLng, lat: this.state.overlayDropLat },
          { lon: getItem.lng, lat: getItem.lat }
        )
      })
      .catch((err) => {
        console.log(err)
      })
  }

  onCloseNotification = () => {
    this.setState({
      showNotification: false,
    })
  }

  openNotification = detail => {
    this.setState({
      showNotification: true,
      infoSearch: {
        location_code: detail.code,
        location_name: detail.name,
      },
    })
  }

  handleShowNearestModal = () => {
    this.setState({
      showListNearestModal: true,
    })
  }

  onCloseNearestModal = () => {
    this.setState({
      showListNearestModal: false,
    })
  }

  handleGetIdForEditOrDelete = objRoute => {
    this.setState({
      getNote: objRoute,
      showModalEditDeleteRoute: true,
    })
  }

  showModalEditDelete = () => {
    this.setState({
      showModalEditDeleteRoute: true,
    })
  }

  onCLoseModalEditDeleteRoute = () => {
    this.setState({
      showModalEditDeleteRoute: false,
    })
  }

  handleShowPlantCpac = () => {
    if (this.state.showPlantCpac == true) {
      if (this.state.plantCpacMarker.length != 0) {
        this.state.plantCpacMarker.map(item => {
          map.Overlays.remove(item)
        })
        this.setState({
          plantCpacMarker: [],
        })
      }
      this.setState({
        showPlantCpac: false,
      })
      return
    }
    this.setState(
      {
        showPlantCpac: true,
      },
      () => {
        if (this.state.objPlantCpacFilterBounds.length > 0) {
          this.displayMarkerPlantCpac(this.state.objPlantCpacFilterBounds)
        } else {
          this.loadData()
        }
      },
    )
  }

  displayMarkerPlantCpac = objPlantCpacFilterBounds => {
    if (objPlantCpacFilterBounds.length > 0) {
      objPlantCpacFilterBounds.map(item => {
        let marker = new window.longdo.Marker(
          { lon: item.lng, lat: item.lat },
          {
            title: item.location_code + ' ' + item.location_name,
            icon: {
              html: renderToString(
                <IconMarkerSmartDispatching image="/img/Group 18442.png" />,
              ),
              //   offset: { x: 12, y: 45 },
            },
            draggable: false,
          },
        )
        this.setState(
          prevState => ({
            plantCpacMarker: [...prevState.plantCpacMarker, marker],
          }),
          () => {
            map.Overlays.add(marker)
          },
        )
      })
    }
  }

  handleShowRoute = () => {
    if (this.state.showRoute == true) {
      if (this.state.keepPolygon.length > 0) {
        this.state.keepPolygon.map(item => {
          map.Overlays.remove(item.overlay)
        })
        this.setState({
          keepPolygon: [],
        })
      }
      this.setState({
        showRoute: false,
      })
      return
    } else if (
      this.state.showRoute == false &&
      this.state.showRouteDoNotEnter == false
    ) {
      const mergeRoute = [
        ...this.state.objRouteFilterBounds,
        ...this.state.objRouteNoFilterBounds,
      ]
      this.setState(
        {
          showRoute: true,
        },
        () => {
          if (mergeRoute.length > 0) {
            this.displayRoutePolygon(mergeRoute)
          } else {
            this.loadData()
          }
        },
      )
    } else if (
      this.state.showRoute == false &&
      this.state.showRouteDoNotEnter == true
    ) {
      this.setState(
        {
          showRoute: true,
        },
        () => {
          if (this.state.getNextPropsRoute.length > 0) {
            this.displayRoutePolygon(this.state.getNextPropsRoute)
          } else {
            this.loadData()
          }
        },
      )
    }
  }

  handleShowRouteDoNotEnter = () => {
    if (this.state.showRouteDoNotEnter == true) {
      if (this.state.keepPolygonDoNoExist.length > 0) {
        this.state.keepPolygonDoNoExist.map(item => {
          map.Overlays.remove(item.overlay)
        })
        this.setState({
          keepPolygonDoNoExist: [],
        })
      }
      this.setState({
        showRouteDoNotEnter: false,
      })
      return
    } else if (
      this.state.showRoute == false &&
      this.state.showRouteDoNotEnter == false
    ) {
      const mergeRoute = [
        ...this.state.objRouteDoNotEnterFilterBounds,
        ...this.state.objRouteDoNotEnterNoFilterBounds,
      ]
      this.setState(
        {
          showRouteDoNotEnter: true,
        },
        () => {
          if (mergeRoute.length > 0) {
            this.displayRoutePolygon(mergeRoute)
          } else {
            this.loadData()
          }
        },
      )
    } else if (
      this.state.showRoute == true &&
      this.state.showRouteDoNotEnter == false
    ) {
      this.setState(
        {
          showRouteDoNotEnter: true,
        },
        () => {
          if (this.state.getNextPropsRoute.length > 0) {
            this.displayRoutePolygon(this.state.getNextPropsRoute)
          } else {
            this.loadData()
          }
        },
      )
    }
  }

  handleShowSiteSmallTruck = () => {
    if (this.state.showSiteSmallTruck == true) {
      if (this.state.siteSmallTruckMarker.length != 0) {
        this.state.siteSmallTruckMarker.map(item => {
          map.Overlays.remove(item)
        })
        this.setState({
          siteSmallTruckMarker: [],
        })
      }
      this.setState({
        showSiteSmallTruck: false,
      })
      return
    }
    this.setState(
      {
        showSiteSmallTruck: true,
      },
      () => {
        if (this.state.objSiteSmallTruckFilterBounds.length > 0) {
          this.displayMarkerSiteSmallTruck(
            this.state.objSiteSmallTruckFilterBounds,
          )
        } else {
          this.loadData()
        }
      },
    )
  }

  displayMarkerSiteSmallTruck = objSiteSmallTruckFilterBounds => {
    if (objSiteSmallTruckFilterBounds.length > 0) {
      objSiteSmallTruckFilterBounds.map(item => {
        let marker = new window.longdo.Marker(
          { lon: item.lng, lat: item.lat },
          {
            title: item.location_code + ' ' + item.location_name,
            icon: {
              html: renderToString(
                <IconMarkerSmartDispatching
                  image={
                    this.props.language == 'th'
                      ? `/img/Group 19862.png`
                      : `/img/Small.png`
                  }
                />,
              ),
              //   offset: { x: 12, y: 45 },
            },
            draggable: false,
          },
        )
        this.setState(
          prevState => ({
            siteSmallTruckMarker: [...prevState.siteSmallTruckMarker, marker],
          }),
          () => {
            map.Overlays.add(marker)
          },
        )
      })
    }
  }

  handleShowSiteLargeTruck = () => {
    if (this.state.showSiteLargeTruck == true) {
      if (this.state.siteLargeTruckMarker.length != 0) {
        this.state.siteLargeTruckMarker.map(item => {
          map.Overlays.remove(item)
        })
        this.setState({
          siteLargeTruckMarker: [],
        })
      }
      this.setState({
        showSiteLargeTruck: false,
      })
      return
    }
    this.setState(
      {
        showSiteLargeTruck: true,
      },
      () => {
        if (this.state.objSiteLargeTruckFilterBounds.length > 0) {
          this.displayMarkerSiteLargeTruck(
            this.state.objSiteLargeTruckFilterBounds,
          )
        } else {
          this.loadData()
        }
      },
    )
  }

  displayMarkerSiteLargeTruck = objSiteLargeTruckFilterBounds => {
    if (objSiteLargeTruckFilterBounds.length > 0) {
      objSiteLargeTruckFilterBounds.map(item => {
        let marker = new window.longdo.Marker(
          { lon: item.lng, lat: item.lat },
          {
            title: item.location_code + ' ' + item.location_name,
            icon: {
              html: renderToString(
                <IconMarkerSmartDispatching
                  image={
                    this.props.language == 'th'
                      ? `/img/Group 19861.png`
                      : `/img/Large.png`
                  }
                />,
              ),
              //   offset: { x: 12, y: 45 },
            },
            draggable: false,
          },
        )
        this.setState(
          prevState => ({
            siteLargeTruckMarker: [...prevState.siteLargeTruckMarker, marker],
          }),
          () => {
            map.Overlays.add(marker)
          },
        )
      })
    }
  }

  clearOverlayOnMap = () => {
    if (this.state.plantCpacMarker.length != 0) {
      this.state.plantCpacMarker.map(item => {
        map.Overlays.remove(item)
      })
      this.setState({
        plantCpacMarker: [],
      })
    }
    if (this.state.keepPolygon.length > 0) {
      this.state.keepPolygon.map(item => {
        map.Overlays.remove(item.overlay)
      })
      this.setState({
        keepPolygon: [],
      })
    }
    if (this.state.siteSmallTruckMarker.length != 0) {
      this.state.siteSmallTruckMarker.map(item => {
        map.Overlays.remove(item)
      })
      this.setState({
        siteSmallTruckMarker: [],
      })
    }
    if (this.state.siteLargeTruckMarker.length != 0) {
      this.state.siteLargeTruckMarker.map(item => {
        map.Overlays.remove(item)
      })
      this.setState({
        siteLargeTruckMarker: [],
      })
    }

    if (this.state.keepMarkerLocation.length > 0) {
      this.state.keepMarkerLocation.map(item => {
        map.Overlays.remove(item.overlay)
      })
      this.setState({
        keepMarkerLocation: [],
      })
    }
  }

  // render longdo map
  initialMap = () => {
    longdo = window.longdo
    map = new window.longdo.Map({
      placeholder: document.getElementById('map'),
      zoom: 6,
    })

    map.location({ lon: 100.49149, lat: 13.75005 }, true)
    map.Ui.Fullscreen.visible(false)
    map.Ui.DPad.visible(false) // เครื่องมือเลื่อนแผนที่ (อยู่บริเวณมุมบนซ้าย)
    map.Ui.Zoombar.visible(false) // แถบซูม (อยู่บริเวณมุมบนซ้าย)
    map.Ui.Geolocation.visible(false) // ปุ่มบอกตำแหน่งปัจจุบัน (อยู่บริเวณมุมบนซ้าย)
    map.Ui.Toolbar.visible(false) // แถบเครื่องมือ (อยู่บริเวณมุมบนซ้าย)
    map.Ui.LayerSelector.visible(false) // ตัวเลือกรูปแบบแผนที (อยู่บริเวณมุมบนขวา)
    map.Ui.Crosshair.visible(false) // สัญลักษณ์แสดงจุดกึ่งกลาง (ตรงกลางแผนที่)
    map.zoom(true, true)
    map.zoomRange({ min: 6, max: 19 })
    map.Layers.externalOptions({
        googleQuery: `key=${this.props.auth.profile.google_map_key}`,
    //   googleQuery: `key=AIzaSyCBh7O-7raiK3L0zOguKR1uAryIwBCQFA4`,
    })
    map.Layers.setBase(longdo.Layers.GOOGLE_ROADMAP)

    map.Ui.Mouse.enableInertia(false)
    map.Ui.Keyboard.enable(false)
    map.zoom(16)
    // this.setState({
    //     maps: window.longdo,
    //     map: map,
    // })
    this.bindMapEvent()
    // return map
  }

  bindMapEvent = () => {
    const self = this
    map.Event.bind('overlayClick', function(overlay) {
      if (overlay.title != undefined && self.state.selectTools == '') {
        let firstSplit = overlay.title.split('(')
        let secondSplit = firstSplit[1].split(')')
        self.setState(
          {
            getMarkerObj: overlay,
            getIdPolygon: secondSplit[0],
          },
          () => {
            let note = self.state.objRoute.filter(
              item => item.id == self.state.getIdPolygon,
            )
            self.handleGetIdForEditOrDelete(note)
          },
        )
      }
    })

    map.Event.bind('overlayChange', function(overlay) {
      const ele = document.getElementsByClassName(
        'ldmap_overlay ldmap_popupholder',
      )
      Array.prototype.forEach.call(ele, function(el) {
        el.style.display =
          self.state.isMenuMapToolsCLick == 'updateRoute' ? '' : 'none'
      })
    })

    map.Event.bind('zoom', function() {
      var result = map.zoom() // Get the zoom value
      let bound = map.bound()
      self.setState(
        {
          initialBoundBox: [
            { lat: bound.maxLat, lng: bound.maxLon },
            { lat: bound.maxLat, lng: bound.minLon },
            { lat: bound.minLat, lng: bound.minLon },
            { lat: bound.minLat, lng: bound.maxLon },
          ],
          //   hideDraw:
          //     !self.state.updatebtn &&
          //     result >= 15 &&
          //     result < 18 &&
          //     self.state.showClear === false
          //       ? true
          //       : false,
        },
        () => {},
      )

      if (
        !self.state.updatebtn &&
        result >= 15 &&
        result < 18 &&
        self.state.showClear === false &&
        self.state.selectTools !== 'pinDoesNotExistInSystem' &&
        self.state.selectTools !== 'directionRoute'
      ) {
        self.loadData()
      }
    })

    map.Event.bind('drop', function() {
      var result = map.zoom() // Get the zoom value
      let bound = map.bound()
      self.setState(
        {
          initialBoundBox: [
            { lat: bound.maxLat, lng: bound.maxLon },
            { lat: bound.maxLat, lng: bound.minLon },
            { lat: bound.minLat, lng: bound.minLon },
            { lat: bound.minLat, lng: bound.maxLon },
          ],
          //   hideDraw:
          //     !self.state.updatebtn &&
          //     result >= 15 &&
          //     result < 18 &&
          //     self.state.showClear === false
          //       ? true
          //       : false,
        },
        () => {
          if (
            !self.state.updatebtn &&
            result >= 15 &&
            result < 18 &&
            self.state.showClear === false &&
            self.state.selectTools !== 'pinDoesNotExistInSystem' &&
            self.state.selectTools !== 'directionRoute'
          ) {
            self.loadData()
          }
        },
      )
    })
  }

  onChangeLatitude = searchLatitudeLongitude => {
    this.setState(
      {
        searchLatitudeLongitude: searchLatitudeLongitude.target.value,
      },
      () => {},
    )
  }

  createRoute = (note, routeName, routeType) => {
    let self = this
    let loading = this.state.loading
    map.Overlays.clear()
    this.props.createSmartDispatching(
      {
        accessToken: '',
        companies_id: this.props.auth.profile.company_id,
        created_user_id: this.props.profile.id,
        small_truck_route: routeType,
        geofence: this.state.geoFene.toString(),
        lat: this.state.geoFene[0].toString(),
        lng: this.state.geoFene[1].toString(),
        remark: note,
        name: routeName,
      },
      loading,
    )
    this.setState(
      {
        keepEditPolygon: [],
        showClear: false,
        getNote: '',
        showSearch: true,
        selectTools: '',
        hideToggleWhenDraw: false,
      },
      () => {
        this.handleFormBack()
        setTimeout(function() {
          self.loadData()
        }, 500)
        this.setState({
          showSearch: true,
          isMenuMapToolsCLick: '',
        })
        this.onCloseModalComfirmpolygon()
      },
    )
  }

  updateRoute = (note, routeName, routeType) => {
    if (this.state.newGeoFene != []) {
      let self = this
      let loading = this.state.loading
      map.Overlays.clear()
      this.props.updateSmartDispatching(
        {
          accessToken: '',
          companies_id: this.props.auth.profile.company_id,
          user_id: this.props.profile.id,
          geofence: this.state.newGeoFene.toString(),
          lat: this.state.data.lat,
          lng: this.state.data.lng,
          id: this.state.getIdPolygon,
          remark: note,
          small_truck_route: routeType,
          name: routeName,
        },
        loading,
      )
      map.Overlays.remove(this.state.keepEditPolygon[0].overlay)
      this.setState(
        {
          updatebtn: false,
          editable: false,
          keepEditPolygon: [],
          getNote: '',
          showSearch: true,
          newGeoFene: [],
          selectTools: '',
          editValue: '',
          hideToggleWhenDraw: false,
        },
        () => {
          this.handleFormBack()
          this.onCloseModalComfirmpolygon()
          setTimeout(function() {
            self.loadData()
          }, 500)
          this.setState({
            showSearch: true,
            isMenuMapToolsCLick: '',
          })
        },
      )
    } else {
      map.Overlays.remove(this.state.keepEditPolygon[0].overlay)
      this.setState(
        {
          updatebtn: false,
          editable: false,
          keepEditPolygon: [],
          getNote: '',
          editValue: '',
        },
        () => {
          this.handleFormBack()
          this.onCloseModalComfirmpolygon()
          setTimeout(function() {
            this.loadData()
          }, 500)
        },
      )
    }
  }

  loadData = async () => {
    await this.clearOverlayOnMap()
    this.postLocationSmartDispatching({
      get_plant: this.state.showPlantCpac,
      get_small_truck_route: this.state.showRoute,
      get_no_small_truck_route: this.state.showRouteDoNotEnter,
      get_small_truck_agency: this.state.showSiteSmallTruck,
      get_big_truck_agency: this.state.showSiteLargeTruck,
      filter_location_name: this.state.suggest_place,
      location_visibility: this.props.auth.profile.location_visibility,
      companies_id: this.props.auth.profile.company_id,
      bounds: this.state.initialBoundBox,
    })
  }

  componentDidMount() {
    appendScript(
      'script',
      `https://cpac-ldbox.longdo.com/map2/?key=${this.props.auth.profile.longdo_map_key}`,
      this,
      this.initialMap
    )
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.state.loadScriptSuccess != nextState.loadScriptSuccess) {
      this.loadData()
    }

    //render polyline previous
    if (
      this.state.previousPolyline.length != nextState.previousPolyline.length
    ) {
      return true
    }

    if (this.state.selectTools != nextState.selectTools) {
      return true
    }

    return true
  }

  handleFormBack = () => {
    this.handleClearAllOverlays()
  }

  rerenderMap = (data, callback) => {
    if (map instanceof window.longdo.Map === false) {
      this.initialMap()
    }
  }

  displayRoutePolygon = data => {
    if (this.state.keepPolygon.length > 0) {
      this.state.keepPolygon.map(item => {
        map.Overlays.remove(item.overlay)
      })
    }
    if (this.state.keepPolygonDoNoExist.length > 0) {
      this.state.keepPolygonDoNoExist.map(item => {
        map.Overlays.remove(item.overlay)
      })
    }

    this.setState({
      objRoute: data,
    })
    let polygonArr = []
    let polygonArrDoNotExist = []
    if (data.length > 0) {
      data.map(value => {
        let polygon = null
        if (value.geofence != '' && value.geofence != undefined) {
          let arr = value.geofence.split(',')
          let convertedStreet = []
          for (let i = 0; i < arr.length; i = i + 2) {
            convertedStreet.push({
              lon: parseFloat(arr[i + 1]),
              lat: parseFloat(arr[i]),
            })
          }
          if (convertedStreet.length > 1) {
            if (this.state.showRoute) {
              polygon = new longdo.Polyline(convertedStreet, {
                title: '(' + value.id.toString() + ')' + ' ' + value.route_name,
                lineWidth: 3,
                lineColor:
                  value.small_truck_route == '1' ? '#FFBA00' : '#F53C56',
                fillColor:
                  value.small_truck_route == '1' ? '#FFBA00' : '#F53C56',
                editable: false,
              })
            }

            if (this.state.showRouteDoNotEnter) {
              polygon = new longdo.Polyline(convertedStreet, {
                title: '(' + value.id.toString() + ')' + ' ' + value.route_name,
                lineWidth: 3,
                lineColor:
                  value.small_truck_route == '1' ? '#FFBA00' : '#F53C56',
                fillColor:
                  value.small_truck_route == '1' ? '#FFBA00' : '#F53C56',
                editable: false,
              })
            }
            if (value.small_truck_route == '1') {
              polygonArr.push({
                id: value.id,
                overlay: polygon,
              })
            } else {
              polygonArrDoNotExist.push({
                id: value.id,
                overlay: polygon,
              })
            }

            map.Overlays.add(polygon)
          }
        }
      })

      this.setState({
        keepPolygon: polygonArr,
        keepPolygonDoNoExist: polygonArrDoNotExist,
      })
    }
  }

  displayMarker = data => {
    let keepPolyginMarker = []

    let tempMarker = []
    if (data.length > 0) {
      let latArr = []
      let lngArr = []

      for (let i = 0; i < data.length; i++) {
        latArr.push(parseFloat(data[i].lat))
        lngArr.push(parseFloat(data[i].lng))
      }
      let minLat = Math.min.apply(null, latArr)
      let minLon = Math.min.apply(null, lngArr)
      let maxLat = Math.max.apply(null, latArr)
      let maxLon = Math.max.apply(null, lngArr)
      let boundbox = { minLon, minLat, maxLon, maxLat }

      data.map(value => {
        let polygon = null
        let circle = null
        let dest_marker = new window.longdo.Marker(
          { lon: value.lng, lat: value.lat },
          {
            title: value.id.toString(),
            dataId: value.id,
            icon: {
              url:
                'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAElklEQVRoge2aT6gVZRjGf8/lIiIuRERcRNCcjXfIEImWIfeARIvCVhEFroKWLQxahASJRIRJRkZk5MZLixCzoptzkBZCFnETnbPxDtKihchFREQuh/O0mJl75pz778yfIy16Lx/zLM687/N83zPvzDdzRcORtMMnjWcx+yTtBvq27wB/SeoEUfxPk/XURJKkHQI8b/weZhaYEmANijiFPWBe6P0giq81Ubu2gMXZcJvEZ4YjBaID0gbJGBVxX3AaczToxMt16tcSkLTDHcDPwHO4kG18fBl4OYjih1U5VBaw2A6nsX+ROOiMmIB1caHgCL4odDiI4n4VHtNVBQjeMRzEazK/b/Sj5JtGU8A+zIuIbcDoSryEeBM4U5FH+Uja4W7jRcz2IUsAQmeQ3w2i7r3iOYvtcBdwEvv1NVLelXgqiLoPynKZKntCxvWI0HZJrPxJgI4h3holD9CK4rvAGxKfSOnvC2OX0atVuFQSIDhse8XLtgGuSv4giOJ1z2tFMZijwI3iuZmjDlfhUlpAMjszbbw/971xbsSTQdTd9EIMOt0ecAo7F57neTZpz5SlU/4itrRLsBUYuoIMV0qk+TW13FDsJM37qAyf8hZyKnrUQsJLJbIsjVoo41J6QksLEH5g6KP0zpp2T2G0p0SaPThrXIM8y5ScfaiyAtJ94YfCSNnAgF8YN4Xxofy8Qp47QRT3ytIpLSC9YyoxeetX1kV0NGmHWzc7f7Edbse8nV6/mYQU3yrLBareB+zrIPBKcWz22v48aYfr5kza4RbwN0hP5MLTEMCNKlwqCQB+H7VQijmC+SmZndmbPWLnxElmZ/ZjIsErK78vWMjwWxUilZ6FBFcHD2TCK2YSlg8BNwULSTuMnU7S00bPgLPfAzZSjkH46mMTgLQALGF2DnWSAZ4yHEAcwNnGJtvhFG2zguXE6HYVKpUsFERxT3B5tYXWwWyC0Xxrg0eQxgWk4R+KXWhdvLrbrMLA91VZVBZgdAmrlxMpdqQhzDq2GeD7QKcqj8oCWlG8JNGpbSFzKYji0nfg2gKyOF/XQuDzdQjUE2BfMH6Ys7azVlTEkLVZr4XvAPN1KNQSEHS692RdWGOHNTwKu7ZhzFzQ6dZ6rVLXQhi+Suc0n9URnG1a7GGcHvV13fq1BUi+Ar41sI0ZwmSCNIyNr0ks1K1fW0AQdftCX5a2EPpio/3zYxMAYHzW+FGKx7GQl4C5Jmo3IqAVde8K5sa1kKSzdV4nFqMRAQBGp8a0UA/4tKm6jQkALwCdMSz0XRDFfzdVtTEBragL8NGmFrI/bqomNLoCYDwv6foGFroiqZEPG3k0KqCVvpn7cAMLnWiidRajUQFZfItJVlkI/pBU67lnrWhcQBDFPUknVlvIx5uefZjMCgCcA24XLHQddHEShSYiIIjiZeD4wEIcCzrVPiFtFpNaAYBzkm5J+lMwkdmfeCTt8LWkHY79zrRKVP7IN2bMGSZinf/jvxKN/K8EsCUb09nIm0N+7BeOvWwsZ6NWNCFgK7CD8h2tD9yjwleZYjS1ApCuQP6da6MVyFeh9uwD/Asypo/TAASupgAAAABJRU5ErkJggg==',
              offset: { x: 12, y: 45 },
            },
            draggable: false,
          },
        )
        tempMarker.push(dest_marker)

        if (value.geo_fence != '' && value.geo_fence != undefined) {
          let location_marker = new window.longdo.Marker(
            { lon: value.lng, lat: value.lat },
            {
              title: value.policy_name,
              detail: value.policy_name,
              icon: {
                html: renderToString(
                  <LocationInfoMarkerLongdoMap
                    key={value.id}
                    lat={value.lat}
                    lng={value.lng}
                    title={value.name}
                  />,
                ),
                offset: { x: 12, y: 45 },
              },
              draggable: false,
            },
          )
          // map.Overlays.add(location_marker)
          // มี geo_fance
          let arr = value.geo_fence.split(',')
          let convertedStreet = []

          for (let i = 0; i < arr.length; i = i + 2) {
            convertedStreet.push({
              lon: parseFloat(arr[i + 1]),
              lat: parseFloat(arr[i]),
            })
          }
          if (convertedStreet.length > 1) {
            polygon = new longdo.Polyline(convertedStreet, {
              // title: value.id.toString(),
              lineWidth: 3,
              lineColor: '#A17DC0',
              fillColor: 'rgba(0, 128, 255, 0.6)',
              editable: false,
            })
            keepPolyginMarker.push({
              id: value.id,
              overlay: polygon,
            })
            map.Overlays.add(polygon)
          }
        } else {
          let location_marker = new window.longdo.Marker(
            { lon: value.lng, lat: value.lat },
            {
              title: value.policy_name,
              detail: value.policy_name,
              icon: {
                html: renderToString(
                  <LocationInfoMarkerLongdoMap
                    key={value.id}
                    lat={value.lat}
                    lng={value.lng}
                    title={value.name}
                  />,
                ),
                offset: { x: 12, y: 45 },
              },
              draggable: false,
            },
          )
          circle = new longdo.Circle(
            {
              lon: value.lng,
              lat: value.lat,
            },
            parseInt(value.radius) / 100000,
            {
              // title: value.id.toString(),
              lineWidth: 3,
              lineColor: '#A17DC0',
              fillColor: 'rgba(0, 128, 255, 0.6)',
            },
          )
          // map.Overlays.add(circle)
          // map.Overlays.add(location_marker)
        }
        map.Overlays.add(dest_marker)
      })

      this.setState({
        tempMarker: [...this.state.tempMarker, ...tempMarker],
        keepMarker: [...this.state.keepMarker, ...keepPolyginMarker],
      })
      map.bound(boundbox)
    }
  }

  editlocation = () => {
    map.Overlays.clear()
    if (this.state.keepCirclePolygon.length > 0) {
      this.state.keepCirclePolygon.map(item => {
        map.Overlays.remove(item.overlay)
      })
    }
    if (this.state.keepPolygonLocation.length > 0) {
      this.state.keepPolygonLocation.map(item => {
        map.Overlays.remove(item.overlay)
      })
    }
    if (this.state.keepMarkerLocation.length > 0) {
      this.state.keepMarkerLocation.map(item => {
        map.Overlays.remove(item.overlay)
      })
    }
    this.setState(
      {
        editable: true,
        visible: false,
        updatebtn: true,
        showSearch: false,
        isMenuMapToolsCLick: 'updateRoute',
        hideToggleWhenDraw: true,
      },
      () => {
        let editLocationObj = this.state.getNextPropsRoute.filter(
          item_id => item_id.id == this.state.getIdPolygon,
        )
        let getFilterPolygonId = this.state.keepPolygon.filter(
          item_id => item_id.id == this.state.getIdPolygon,
        )
        // map.Overlays.remove(getFilterPolygonId[0].overlay)
        this.displayEditPolygon(editLocationObj)
      },
    )
  }

  displayEditPolygon(ListsView) {
    let value = ListsView[0]
    // let markerArr = []
    let polygonArr = []
    this.setState({
      data: {
        id: value.id,
        lat: value.lat,
        lng: value.lng,
        name: 'รถโม่เล็ก',
        geoFene: [],
      },
      selectTools: value.small_truck_route,
      editValue: value,
    })
    if (value.radius === '') {
    } else {
      // polygon
      this.setState({ haveMarkerOnMap: true })
      let arr = value.geofence.split(',')
      let convertedStreet = []
      let self = this
      let polygon = null
      for (let i = 0; i < arr.length; i = i + 2) {
        convertedStreet.push({
          lon: parseFloat(arr[i + 1]),
          lat: parseFloat(arr[i]),
        })
      }
      polygon = new longdo.Polyline(convertedStreet, {
        title: '(' + value.id.toString() + ')' + ' ' + value.route_name,
        lineWidth: 3,
        lineColor: value.small_truck_route == '1' ? '#FFBA00' : '#F53C56',
        fillColor: value.small_truck_route == '1' ? '#FFBA00' : '#F53C56',
        editable: true,
      })

      polygonArr.push({
        id: parseInt(value.id),
        overlay: polygon,
      })
      this.setState(
        {
          keepEditPolygon: polygonArr,
        },
        () => {},
      )
      if (polygon != null) {
        polygon.location().map(val => {
          self.state.newGeoFene.push(val.lat, val.lon)
        })
      }
      map.Overlays.add(polygon)
      this.setState({ polygonLayer: polygon })

      map.Event.bind('overlayDrop', function() {
        if (self.state.isMenuMapToolsCLick == 'updateRoute') {
          if (polygon != null) map.Overlays.remove(self.state.polygonLayer)
          self.setState({ polygonLayer: null })

          self.state.newGeoFene = []

          if (polygon != null) {
            polygon.location().map(val => {
              self.state.newGeoFene.push(val.lat, val.lon)
            })
          }
          map.Overlays.add(polygon)
          self.setState({ polygonLayer: polygon })
        }
      })

      //   map.location({ lon: value.lng, lat: value.lat }, true)
      map.zoom(17)
      this.setState({
        hideDraw: false,
      })
    }
  }

  displayPreviousPolygon = (ListsView, text) => {
    map.Overlays.clear()
    // polygon
    let arr = ListsView
    let convertedStreet = []
    let self = this
    let polygon = null
    for (let i = 0; i < arr.length; i = i + 2) {
      convertedStreet.push({
        lon: parseFloat(arr[i + 1]),
        lat: parseFloat(arr[i]),
      })
    }
    if (convertedStreet.length == 1) {
      this.setState(
        {
          geoFene: [],
          previousPolyline: [],
          hideDraw: false,
        },
        () => this.handleCancelDrawPolygon(),
      )

      return
    }
    polygon = new longdo.Polyline(convertedStreet, {
      lineWidth: 3,
      lineColor: text == '1' ? '#FFBA00' : '#F53C56',
      fillColor: text == '1' ? '#FFBA00' : '#F53C56',
      //   editable: true,
    })
    this.setState({
      geoFene: ListsView,
    })

    map.Overlays.add(polygon)
  }

  deletelocation = () => {
    this.setState(
      {
        visible: false,
      },
      () => {
        let self = this
        let filterPolygon = this.state.keepMarker.filter(
          item => item.id == this.state.getIdPolygon,
        )
        axios
          .delete(
            `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/small-truck-route/delete/${this.state.getIdPolygon}`,
            {
              headers: {
                Authorization: `Bearer ${this.props.auth.accessToken}`,
              },
            },
          )
          .then(function(response) {
            // self.handleFormBack()
            map.Overlays.clear()
            self.loadData()
            this.setState({
              showSearch: true,
              isMenuMapToolsCLick: '',
            })
          })
          .catch(function(error) {
            console.log(error)
          })

        message.success(`delete success`)
      },
    )
  }

  // Clear Map
  handleClearLocationMarker = () => {
    if (this.state.Marker != null) {
      // Marker
      this.displayMarker([])
      map.Overlays.remove(this.state.Marker)
      this.setState({
        Marker: [],
      })
    }

    if (this.state.circle != null) {
      // วงกลม
      map.Overlays.remove(this.state.circle)
      this.setState({
        circle: null,
      })
    }

    if (this.state.geoFene.length > 0) {
      this.state.geoFene.splice(0, this.state.geoFene.length)
    }
  }

  handleClearAllOverlays = () => {
    this.handleClearLocationMarker()
    this.handleClearDrawPolygon()

    this.setState({
      isMenuMapToolsCLick: '',
      data: {
        ...this.state.data,
        lat: '',
        lng: '',
      },
      geoFene: [],
      showSearch: false,
    })
  }

  handleSavePolygon = (note, routeName, routeType) => {
    this.createRoute(note, routeName, routeType)
  }

  handleUpdatePolygon = (note, routeName, routeType) => {
    this.updateRoute(note, routeName, routeType)
  }

  handleCancelEditPolygon = () => {
    map.Overlays.remove(this.state.keepEditPolygon[0].overlay)
    this.setState(
      {
        updatebtn: false,
        editable: false,
        keepEditPolygon: [],
        getNote: '',
        selectTools: '',
        showClear: false,
        hideDraw: true,
        geoFene: [],
        previousPolyline: [],
        newGeoFene: [],
      },
      () => {
        this.handleFormBack()
        this.loadData()
        this.setState({
          showSearch: true,
          isMenuMapToolsCLick: '',
          hideToggleWhenDraw: false,
        })
      },
    )
  }

  handleCancelDrawPolygon = () => {
    map.Overlays.clear()
    this.setState(
      {
        showClear: false,
        isMenuMapToolsCLick: '',
        hideDraw: true,
        getNote: '',
        selectTools: '',
        geoFene: [],
        previousPolyline: [],
        newGeoFene: [],
      },
      () => {
        this.handleFormBack()
        this.setState({
          showSearch: true,
          hideToggleWhenDraw: false,
        })
        this.loadData()
      },
    )
  }

  clearAreaMarkerUnloadPoint = () => {
    if (this.state.unload_point_area_Polyline != null) {
      map.Overlays.remove(this.state.unload_point_area_Polyline)
      this.setState({
        unload_point_area_Polyline: null,
      })
    }
    if (this.state.unload_point_area_Polygon != null) {
      map.Overlays.remove(this.state.unload_point_area_Polygon)
      this.setState({
        unload_point_area_Polygon: null,
      })
    }
    if (this.state.unload_point_pin_marker != null) {
      map.Overlays.remove(this.state.unload_point_pin_marker)
      this.setState({
        unload_point_pin_marker: null,
      })
    }

    this.setState({
      unload_point_show_Area: false,
      unload_point_area_Polyline: [],
      // unload_point_geofene: [],
    })
  }

  handleClearDrawPolygon = () => {
    if (this.state.marker != null) {
      // Marker
      map.Overlays.remove(this.state.marker)
      this.setState({
        marker: null,
      })
    }
    if (this.state.polygon != null) {
      // Polygon
      map.Overlays.remove(this.state.polygon)
      this.setState({
        polygon: null,
      })
    }
    if (this.state.polyline != null) {
      map.Overlays.remove(this.state.polyline)
      this.setState({
        polyline: null,
      })
    }
    if (this.state.geoFene.length > 0) {
      this.state.geoFene.splice(0, this.state.geoFene.length)
    }
  }

  handleGotoLocation = value => {
    let self = this
    map.location({ lon: value.lng, lat: value.lat })
    setTimeout(() => {
      let bound = map.bound()
      self.setState(
        {
          initialBoundBox: [
            { lat: bound.maxLat, lng: bound.maxLon },
            { lat: bound.maxLat, lng: bound.minLon },
            { lat: bound.minLat, lng: bound.minLon },
            { lat: bound.minLat, lng: bound.maxLon },
          ],
        },
        async () => {
          await self.clearOverlayOnMap()
          this.setState(
            {
              loading: true,
              hideDraw: false,
            },
            () => {
              axios({
                method: 'post',
                url: `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/small-truck-route/locations`,
                headers: {
                  Authorization: `Bearer ${this.props.auth.accessToken}`,
                },
                data: {
                  get_plant: self.state.showPlantCpac,
                  get_small_truck_route: self.state.showRoute,
                  get_no_small_truck_route: self.state.showRouteDoNotEnter,
                  get_small_truck_agency: self.state.showSiteSmallTruck,
                  get_big_truck_agency: self.state.showSiteLargeTruck,
                  filter_location_name: '',
                  location_visibility:
                    self.props.auth.profile.location_visibility,
                  companies_id: self.props.auth.profile.company_id,
                  bounds: self.state.initialBoundBox,
                },
              }).then(response => {
                this.setState(
                  {
                    showSearchStartEndLocation:
                      this.state.suggestPlace != '' ? true : false,

                    showNeighborhoodInformation:
                      this.state.suggest_place != '' ? true : false,
                    loading: false,
                    //Cpac Plant
                    objPlantCpacFilterBounds: response.data.plant.filter_bounds,
                    objPlantCpacNoFilterBounds:
                      response.data.big_truck_agency.no_filter_bounds,
                    //End Cpac Plant

                    //Route
                    objRouteFilterBounds:
                      response.data.small_truck_route.filter_bounds,
                    objRouteDoNotEnterFilterBounds:
                      response.data.no_small_truck_route.filter_bounds,
                    objRouteNoFilterBounds:
                      response.data.small_truck_route.no_filter_bounds,
                    objRouteDoNotEnterNoFilterBounds:
                      response.data.no_small_truck_route.no_filter_bounds,
                    //End Route

                    //SmallTruckRoute
                    objSiteSmallTruckFilterBounds:
                      response.data.small_truck_agency.filter_bounds,
                    objSiteSmallTruckNoFilterBounds:
                      response.data.small_truck_agency.no_filter_bounds,
                    //End SmallSmallTruckRoute

                    //LargeTruckRoute
                    objSiteLargeTruckFilterBounds:
                      response.data.big_truck_agency.filter_bounds,
                    objSiteLargeTruckNoFilterBounds:
                      response.data.big_truck_agency.no_filter_bounds,
                    //EndTruckRoute
                  },
                  async () => {
                    let mergeRoute = [
                      ...this.state.objRouteFilterBounds,
                      ...this.state.objRouteDoNotEnterFilterBounds,
                      ...this.state.objRouteNoFilterBounds,
                      ...this.state.objRouteDoNotEnterNoFilterBounds,
                    ]
                    this.setState({
                      getNextPropsRoute: mergeRoute,
                    })
                    this.displayMarkerSiteSmallTruck(
                      this.state.objSiteSmallTruckFilterBounds,
                    )
                    this.displayMarkerSiteLargeTruck(
                      this.state.objSiteLargeTruckFilterBounds,
                    )
                    this.displayRoutePolygon(mergeRoute)
                    //   this.displayRoutePolygon(
                    //     this.state.objRouteDoNotEnterFilterBounds,
                    //   )
                    this.displayMarkerPlantCpac(
                      this.state.objPlantCpacFilterBounds,
                    )
                  },
                )
              })
            },
          )
        },
      )
    }, 1000)
  }

  handleZoomIn = () => {
    map.zoom(true, true)
  }

  handleZoomOut = () => {
    map.zoom(false, true)
  }

  handleShowTrafficLayer = () => {
    if (this.state.showTrafficLayer) {
      map.Layers.remove(longdo.Layers.TRAFFIC)
      this.setState({
        showTrafficLayer: false,
      })
    } else {
      map.Layers.add(longdo.Layers.TRAFFIC)
      this.setState({
        showTrafficLayer: true,
      })
    }
  }

  handleCancel = () => {
    this.setState({
      visible: false,
      isMenuMapToolsCLick: '',
    })
  }

  confirmCreatePolygon = () => {
    let index = this.state.tempMarker.findIndex(
      x => x.title == this.state.getIdPolygon,
    )
    let filterPolygon = this.state.keepMarker.filter(
      item => item.id == this.state.getIdPolygon,
    )
    let value = this.state.apiData.filter(
      item => item.id == this.state.getIdPolygon,
    )
    let dataForm = [
      {
        geo_fence: this.state.geoFene.toString(),
        id: this.state.getIdPolygon,
        lat: value[0].lat,
        lng: value[0].lng,
        name: 'รถโม่เล็ก',
      },
    ]
    if (index > -1) {
      map.Overlays.remove(this.state.tempMarker[index])
      map.Overlays.remove(filterPolygon[0].overlay)
    }
    this.displayMarker(dataForm)
    this.setState(
      {
        geoFene: [],
        editable: false,
      },
      () => {
        message.success(`save success`)
      },
    )
  }

  handleSelectTool = type => {
    this.setState({ selectTools: type })
  }

  // Draw Polygon
  handleDrawPolyline = text => {
    this.setState({
      selectTools: text,
      editValue: {
        route_name: '',
        remark: '',
      },
    })
    map.Overlays.clear()
    if (this.state.keepCirclePolygon.length > 0) {
      this.state.keepCirclePolygon.map(item => {
        map.Overlays.remove(item.overlay)
      })
    }
    if (this.state.keepPolygonLocation.length > 0) {
      this.state.keepPolygonLocation.map(item => {
        map.Overlays.remove(item.overlay)
      })
    }
    if (this.state.keepMarkerLocation.length > 0) {
      this.state.keepMarkerLocation.map(item => {
        map.Overlays.remove(item.overlay)
      })
    }

    let self = this
    let polygon = null
    let array_latlng = []
    let geoFene = []
    let polyline = null

    self.clearAreaMarkerUnloadPoint()
    this.displayMarker([])
    this.setState({
      isMenuMapToolsCLick: 'findArea',
      showClear: true,
      showSearch: false,
      hideToggleWhenDraw: true,
      getNote: '',
    })

    map.Event.bind('click', function(overlay) {
      if (self.state.circle != null) {
        // วงกลม
        map.Overlays.remove(self.state.circle)
      }
      if (self.state.marker != null) {
        map.Overlays.remove(self.state.marker)
        self.setState({ marker: null })
      }

      //   if(self.state.polyline != null){
      //     map.Overlays.remove(self.state.marker)
      //   }

      if (self.state.isMenuMapToolsCLick == 'findArea') {
        self.handleClearDrawPolygon()
        let latlng = map.location(longdo.LocationMode.Pointer)

        array_latlng.push({
          lon: parseFloat(latlng.lon.toFixed(6)),
          lat: parseFloat(latlng.lat.toFixed(6)),
        })

        geoFene.push(
          parseFloat(latlng.lat.toFixed(6)),
          parseFloat(latlng.lon.toFixed(6)),
        )
        // self.state.geoFene.push(
        //   parseFloat(latlng.lat.toFixed(6)),
        //   parseFloat(latlng.lon.toFixed(6)),
        // )
        const geoFenes = [...geoFene]

        self.setState(
          {
            previousPolyline: array_latlng,
            geoFene: geoFenes,
          },
          () => {
            randerPolygon()
          },
        )
      }
    })

    function randerPolygon() {
      //   const geoFenes = [...geoFene]

      if (array_latlng.length >= 2) {
        polyline = new longdo.Polyline(array_latlng, {
          //   editable: true,
          lineWidth: 3,
          lineColor: text == '1' ? '#FFBA00' : '#F53C56',
        })
        map.Overlays.add(polyline)
        self.setState({ polyline: polyline })
      }
    }

    map.Event.bind('overlayDrop', function(overlay) {
      const temp = [...array_latlng]
      if (self.state.isMenuMapToolsCLick == 'findArea') {
        self.handleClearDrawPolygon()
        self.state.geoFene = []
        let arrPolyLine = []

        if (polyline != null) {
          polyline.location().map(val => {
            arrPolyLine.push(val.lat, val.lon)
          })

          polyline = new longdo.Polyline(polyline.location(), {
            editable: true,
            lineWidth: 3,
            lineColor: text == '1' ? '#FFBA00' : '#F53C56',
          })

          self.setState({
            data: {
              ...self.state.data,
            },
          })
        }

        map.Overlays.add(polyline)
        self.setState({ polyline: polyline, geoFene: arrPolyLine })
      }
    })
  }
  // End Drawing Area

  handleMapTypeSatellite = e => {
    // longdo.setMapTypeId('satellite')
    map.Layers.setBase(longdo.Layers.GOOGLE_HYBRID)
  }

  handleMapTypeTerrain = e => {
    // longdo.setMapTypeId('terrain')
    map.Layers.setBase(longdo.Layers.GOOGLE_ROADMAP)
  }

  openModalConfirmPolygon = () => {
    this.setState({
      showComfirmSavePolygon: true,
    })
  }

  onCloseModalComfirmpolygon = () => {
    this.setState({
      showComfirmSavePolygon: false,
    })
  }

  handlePinDoesNotExistInSystem = location => {
    // this.handleCancelDrawPolygon()
    this.setState(
      {
        selectTools: 'pinDoesNotExistInSystem',
        showSearch: true,
        hideToggleWhenDraw: false,
      },
      () => {
        let self = this
        let my_location = new window.longdo.Marker(
          { lon: location.lon, lat: location.lat },
          {
            icon: {
              html: renderToString(
                <IconMyLocation
                  image="/img/Component 14 – 49.png"
                  title={i18n[this.props.language].y.you}
                />,
              ),
              offset: { x: 12, y: 45 },
            },
            draggable: true,
          },
        )
        map.Overlays.add(my_location)
        this.setState({
          my_location: my_location,
        })

        map.Event.bind('overlayDrop', function(overlay) {
          console.log('overlayDrop', overlay, self.state.selectTools)
          if (self.state.selectTools == 'pinDoesNotExistInSystem') {
            self.setState({
              btnCarThisArea: true,
              overlayDropLat: overlay.location().lat,
              overlayDropLng: overlay.location().lon,
            })
          }
        })
      },
    )
  }

  handlePrevious = previousGeofene => {
    if (previousGeofene.length != 0) {
      previousGeofene.pop()

      this.setState(
        {
          previousPolyline: previousGeofene,
        },
        () => {
          let arr = []
          this.state.previousPolyline.forEach(element => {
            arr.push(element.lat)
            arr.push(element.lon)
          })
          this.setState(
            {
              geoFene: arr,
            },
            () => {
              this.displayPreviousPolygon(
                this.state.geoFene,
                this.state.selectTools,
              )
            },
          )
        },
      )
    }
  }

  handleGetLocationFromSearch = value => {
    this.setState(
      {
        overlayDropLat: value.lat,
        overlayDropLng: value.lng,
        startPointLocationName: value.name,
      },
      () => {
        this.handleFindCarThisArea()
      },
    )
  }

  handleFindCarThisArea = () => {
    this.setState(
      {
        btnCarThisArea: false,
        loading: true,
      },
      () => {
        axios({
          method: 'post',
          url: `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/small-truck-route/nearbylocations`, // API URL
          headers: { Authorization: `Bearer ${this.props.auth.accessToken}` },
          data: {
            company_id: this.props.auth.profile.company_id,
            lat: this.state.overlayDropLat,
            lng: this.state.overlayDropLng,
            location_visibility: this.props.auth.profile.location_visibility,
          },
        }).then(res => {
          if (res.data.data.length > 0) {
            res.data.data.map((item, index) => {
              axios({
                method: 'get',
                url: `https://cpac-ldbox.longdo.com/map/mmroute/json/route/guide?flon=${this.state.overlayDropLng}&flat=${this.state.overlayDropLat}&tlon=${item.lng}&tlat=${item.lat}&mode=driving&type=17&locale=th&key=${this.props.auth.profile.longdo_map_key}`,
              })
                .then((res2) => {
                  res.data.data[index].distance = res2.data.data.tdistance
                })
                .catch((err) => {
                  console.log(err)
                })
            })
            let sortingArray = res.data.data.sort(function compare(a, b) {
              if (a.distance < b.distance) {
                return -1
              }
              if (a.distance > b.distance) {
                return 1
              }
              return 0
            })
            this.setState(
              {
                nearByLocationList: sortingArray,
                loading: false,
                startPointLocationName:
                  i18n[this.props.language].y.yourLocation,
              },
              () => {
                if (this.state.nearByLocationList.length > 0) {
                  this.handleShowNearestModal()
                } else {
                  message.error('location is empty')
                }
              },
            )
          } else {
            message.error('location is wrong')
          }
        })
      },
    )
  }

  onCloseSearchStartEndLocation = () => {
    if (this.state.routePolyline != null) {
      map.Overlays.remove(this.state.routePolyline)
      this.setState({
        routePolyline: null,
      })
    }
    if (this.state.my_location != null) {
      map.Overlays.remove(this.state.my_location)
      this.setState({
        my_location: null,
      })
    }
    if (this.state.end_marker != null) {
      map.Overlays.remove(this.state.end_marker)
      this.setState({
        end_marker: null,
      })
    }
    if (this.state.start_marker != null) {
      map.Overlays.remove(this.state.start_marker)
      this.setState({
        start_marker: null,
      })
    }
    this.setState({
      showSearchStartEndLocation: false,
      selectTools: '',
      hideDraw: false,
      showSearch: true,
    })
  }

  handleShowSearchStartEndLocation = () => {
    this.setState({
      showSearchStartEndLocation: true,
    })
  }

  handleMarkerPopup = () => {
    let popupMarker = new window.longdo.Popup(
      { lon: 100.4953296482563, lat: 13.756622178904763 },
      {
        html: renderToString(
          <PopupMarkerSmartDispatching
            style={{
              zIndex: 999,
              //   display: 'inline-flex',
              textAlign: 'center',
              alignItems: 'center',
              justifyContent: 'center',
              transform: 'translate(-50%, -180%)',
              position: 'absolute',
              marginLeft: '15px',
            }}
            image="/img/Direct.png"
            title="หน่วยงานสาทร 11"
          />,
        ),
        offset: { x: 12, y: 45 },
      },
    )
    map.Overlays.add(popupMarker)
  }

  render() {
    const { loading } = this.props.SmartDispatching
    const mapTools = (
      <Menu
        style={{
          width: this.props.language == 'th' ? `260px` : `300px`,
          right: this.props.language == 'th' ? 0 : -130,
          borderRadius: 10,
        }}
      >
        <Menu.Item
          key="3"
          onClick={() => {
            this.handleDrawPolyline('1')
          }}
          disabled={this.state.hideDraw}
          style={{ marginBottom: '5px' }}
        >
          <Icon type="highlight" style={{ color: '#FFBA00' }} />
          <LangContext.Consumer>
            {i18n => i18n.d.drawSmallTruckRoute}
          </LangContext.Consumer>
        </Menu.Item>
        <Menu.Item
          key="4"
          onClick={() => {
            this.handleDrawPolyline('2')
          }}
          disabled={this.state.hideDraw}
          style={{ marginBottom: '5px' }}
        >
          <Icon type="highlight" style={{ color: '#F53C56' }} />
          <LangContext.Consumer>
            {i18n => i18n.d.drawSmallTruckRouteDoNotEnter}
          </LangContext.Consumer>
        </Menu.Item>
        <Menu.Item
          key="5"
          onClick={() => {
            this.handlePinDoesNotExistInSystem(map.location())
          }}
          disabled={this.state.hideDraw}
        >
          <Icon type="pushpin" />
          <LangContext.Consumer>
            {i18n => i18n.p.pinDoesNotExistInSystem}
          </LangContext.Consumer>
        </Menu.Item>
      </Menu>
    )

    const mapType = (
      <Menu style={{ borderRadius: '10px' }}>
        <Menu.Item
          key="1"
          onClick={this.handleMapTypeSatellite}
          style={{ marginBottom: '5px' }}
        >
          <LangContext.Consumer>
            {i18n => i18n.s.satellite}
          </LangContext.Consumer>
        </Menu.Item>
        <Menu.Item key="2" onClick={this.handleMapTypeTerrain}>
          <LangContext.Consumer>{i18n => i18n.m.map}</LangContext.Consumer>
        </Menu.Item>
      </Menu>
    )

    return (
      <AuthorizeComponent {...this.props} matching_name="smartDispatching">
        <Spin spinning={loading}>
          <SmartDispatchLayout>
            <Row gutter={24}>
              <Spin spinning={this.state.loading}>
                <Col
                  sm={24}
                  md={24}
                  lg={24}
                  xl={24}
                  style={{ paddingLeft: '0px', paddingRight: '0px' }}
                >
                  {this.state.showSearch &&
                    !this.state.showSearchStartEndLocation && (
                      <div
                        style={{
                          position: 'absolute',
                          marginTop: '4px',
                          top: '5px',
                          left: '5px',
                          zIndex: '12',
                        }}
                      >
                        <LangContext.Consumer>
                          {i18n => (
                            <Input
                              placeholder={i18n.f.findTheDesiredLocation}
                              suffix={
                                <>
                                  <Icon
                                    type="search"
                                    style={{
                                      color: 'red',
                                      fontSize: '1.2rem',
                                    }}
                                    onClick={() => {
                                      let result = map.zoom()
                                      if (result >= 15) {
                                        this.loadData()
                                      } else {
                                        message.config({
                                          top: 160,
                                        })
                                        message.error(i18n.t.tooMuchZoom)
                                      }
                                    }}
                                  />
                                  {this.state.showNeighborhoodInformation && (
                                    <>
                                      <Divider type="vertical" />
                                      <Icon
                                        type="close"
                                        style={{
                                          color: 'red',
                                          fontSize: '1.2rem',
                                        }}
                                        onClick={() => {
                                          this.setState(
                                            {
                                              suggest_place: '',
                                              showNeighborhoodInformation: false,
                                            },
                                            () => {
                                              this.loadData()
                                            },
                                          )
                                        }}
                                      />
                                    </>
                                  )}
                                </>
                              }
                              onChange={e => {
                                this.setState({
                                  suggest_place: e.target.value,
                                })
                              }}
                              onPressEnter={() => {
                                let result = map.zoom()
                                if (result >= 15) {
                                  this.loadData()
                                } else {
                                  message.config({
                                    top: 160,
                                  })
                                  message.error(i18n.t.tooMuchZoom)
                                }
                              }}
                              size="large"
                              value={this.state.suggest_place}
                              className="button-search-smart-dispatching"
                            />
                          )}
                        </LangContext.Consumer>
                      </div>
                    )}
                  {!this.state.hideToggleWhenDraw && (
                    <div
                      style={{
                        position: 'absolute',
                        marginTop: '4px',
                        top: '13px',
                        left: '22%',
                        zIndex: '12',
                      }}
                    >
                      <Button
                        type={this.state.showPlantCpac ? 'primary' : ''}
                        shape="round"
                        style={{
                          marginRight: '10px',
                          color: this.state.showPlantCpac ? 'white' : '#172B4D',
                        }}
                        onClick={() => {
                          this.handleShowPlantCpac()
                        }}
                      >
                        <LangContext.Consumer>
                          {i18n => i18n.s.showCpacPlant}
                        </LangContext.Consumer>
                      </Button>
                      <Button
                        type={this.state.showRoute ? 'primary' : ''}
                        shape="round"
                        style={{
                          marginRight: '10px',
                          color: this.state.showRoute ? 'white' : '#172B4D',
                        }}
                        onClick={() => {
                          this.handleShowRoute()
                        }}
                      >
                        <LangContext.Consumer>
                          {i18n => i18n.s.smallTruckRoute}
                        </LangContext.Consumer>
                      </Button>
                      <Button
                        type={this.state.showRouteDoNotEnter ? 'primary' : ''}
                        shape="round"
                        style={{
                          marginRight: '10px',
                          color: this.state.showRouteDoNotEnter
                            ? 'white'
                            : '#172B4D',
                        }}
                        onClick={() => this.handleShowRouteDoNotEnter()}
                      >
                        <LangContext.Consumer>
                          {i18n => i18n.s.smallTruckRouteDoNotEnter}
                        </LangContext.Consumer>
                      </Button>
                      <Button
                        type={this.state.showSiteSmallTruck ? 'primary' : ''}
                        shape="round"
                        style={{
                          marginRight: '10px',
                          color: this.state.showSiteSmallTruck
                            ? 'white'
                            : '#172B4D',
                        }}
                        onClick={() => this.handleShowSiteSmallTruck()}
                      >
                        <LangContext.Consumer>
                          {i18n => i18n.s.siteSmallTruck}
                        </LangContext.Consumer>
                      </Button>
                      <Button
                        type={this.state.showSiteLargeTruck ? 'primary' : ''}
                        shape="round"
                        style={{
                          marginRight: '10px',
                          color: this.state.showSiteLargeTruck
                            ? 'white'
                            : '#172B4D',
                        }}
                        onClick={() => this.handleShowSiteLargeTruck()}
                      >
                        <LangContext.Consumer>
                          {i18n => i18n.s.siteLargeTruck}
                        </LangContext.Consumer>
                      </Button>
                    </div>
                  )}

                  {this.state.showNeighborhoodInformation && (
                    <div
                      style={{
                        position: 'absolute',
                        marginTop: '4px',
                        top: '61px',
                        left: '5px',
                        zIndex: '12',
                      }}
                    >
                      <NeighborhoodInformation
                        handleGetIdForEditOrDelete={
                          this.handleGetIdForEditOrDelete
                        }
                        handleMarkerPopup={this.handleMarkerPopup}
                        handleShowNearestModal={this.handleShowNearestModal}
                        allDataFromSearch={this.state.allDataFromSearch}
                        openNotification={this.openNotification}
                        handleGotoLocation={this.handleGotoLocation}
                        handleGetLocationFromSearch={
                          this.handleGetLocationFromSearch
                        }
                      />
                    </div>
                  )}

                  {this.state.showSearchStartEndLocation && (
                    <div
                      style={{
                        position: 'absolute',
                        marginTop: '4px',
                        top: '5px',
                        left: '5px',
                        zIndex: '12',
                      }}
                    >
                      <SearchStartEndLocation
                        onClose={this.onCloseSearchStartEndLocation}
                        startLocation={this.state.startPointLocationName}
                        endLocation={this.state.endPointLocationName}
                        handleShowNearestModal={this.handleShowNearestModal}
                        disabled={true}
                      />
                    </div>
                  )}

                  <div
                    style={{
                      position: 'absolute',
                      marginTop: '4px',
                      top: '13px',
                      right: '0px',
                      zIndex: '12',
                    }}
                  >
                    <ButtonGroup
                      style={{
                        marginRight: '4px',
                      }}
                    >
                      <Dropdown
                        className="edge-element"
                        overlay={mapTools}
                        disabled={
                          this.state.isMenuMapToolsCLick == 'updateRoute'
                            ? true
                            : false
                        }
                      >
                        <Button
                          size="default"
                          style={{
                            color:
                              this.state.isMenuMapToolsCLick == 'updateRoute'
                                ? 'gray'
                                : '#172B4D',
                            height: '40px',
                            width: '130px',
                            borderRadius: '10px 0px 0px 10px',
                            border: '0px 0px 1px 0px',
                          }}
                        >
                          <LangContext.Consumer>
                            {i18n => i18n.t.tools}
                          </LangContext.Consumer>{' '}
                          <Icon type="down" />
                        </Button>
                      </Dropdown>
                      <Dropdown className="edge-element" overlay={mapType}>
                        <Button
                          size="default"
                          style={{
                            color: '#172B4D',
                            width: '130px',
                            height: '40px',
                            borderRadius: '0px 10px 10px 0px',
                          }}
                        >
                          <LangContext.Consumer>
                            {i18n => i18n.m.mapview}
                          </LangContext.Consumer>{' '}
                          <Icon type="down" />
                        </Button>
                      </Dropdown>
                    </ButtonGroup>
                  </div>
                  {this.state.btnCarThisArea && (
                    <div
                      style={{
                        position: 'absolute',
                        bottom: '15px',
                        zIndex: '12',
                        width: '100%',
                        textAlign: 'center',
                      }}
                    >
                      <Button
                        type="primary"
                        shape="round"
                        style={{
                          marginRight: '10px',
                          color: 'white',
                        }}
                        onClick={() => this.handleFindCarThisArea()}
                      >
                        <LangContext.Consumer>
                          {i18n => i18n.f.findCarThisArea}
                        </LangContext.Consumer>
                      </Button>
                    </div>
                  )}

                  {this.state.selectTools != '' && (
                    <div
                      style={{
                        position: 'absolute',
                        marginTop: '4px',
                        top: '60px',
                        right: '0px',
                        zIndex: '12',
                      }}
                    >
                      <ButtonGroup
                        style={{
                          marginRight: '4px',
                        }}
                      >
                        {this.state.selectTools == '1' &&
                          this.state.isMenuMapToolsCLick !== 'updateRoute' && (
                            <span
                              style={{
                                backgroundColor: 'white',
                                padding: 10,
                                color: '#FFBA00',
                                borderRadius: '5px 0 0 5px',
                                minWidth: '250px',
                                textAlign: 'center',
                              }}
                            >
                              <Icon type="highlight" />{' '}
                              <LangContext.Consumer>
                                {i18n => i18n.d.drawSmallTruckRoute}
                              </LangContext.Consumer>
                            </span>
                          )}

                        {this.state.selectTools == '2' &&
                          this.state.isMenuMapToolsCLick !== 'updateRoute' && (
                            <span
                              style={{
                                backgroundColor: 'white',
                                padding: 10,
                                color: '#F53C56',
                                borderRadius: '5px 0 0 5px',
                                minWidth: '250px',
                                textAlign: 'center',
                              }}
                            >
                              <Icon type="highlight" />{' '}
                              <LangContext.Consumer>
                                {i18n => i18n.d.drawSmallTruckRouteDoNotEnter}
                              </LangContext.Consumer>
                            </span>
                          )}

                        {this.state.selectTools == '1' &&
                          this.state.isMenuMapToolsCLick === 'updateRoute' && (
                            <div
                              style={{
                                backgroundColor: 'white',
                                padding: 10,
                                color: '#FFBA00',
                                borderRadius: 5,
                                minWidth: '235px',
                                textAlign: 'center',
                              }}
                            >
                              <Icon type="highlight" />{' '}
                              <LangContext.Consumer>
                                {i18n => i18n.d.drawSmallTruckRoute}
                              </LangContext.Consumer>
                            </div>
                          )}

                        {this.state.selectTools == '2' &&
                          this.state.isMenuMapToolsCLick === 'updateRoute' && (
                            <div
                              style={{
                                backgroundColor: 'white',
                                padding: 10,
                                color: '#F53C56',
                                borderRadius: 5,
                                minWidth: '235px',
                                textAlign: 'center',
                              }}
                            >
                              <Icon type="highlight" />{' '}
                              <LangContext.Consumer>
                                {i18n => i18n.d.drawSmallTruckRouteDoNotEnter}
                              </LangContext.Consumer>
                            </div>
                          )}

                        {this.state.selectTools == 'pinDoesNotExistInSystem' &&
                          this.state.isMenuMapToolsCLick !== 'updateRoute' && (
                            <div
                              style={{
                                backgroundColor: 'white',
                                padding: 10,
                                color: '#172B4D',
                                borderRadius: 5,
                                minWidth: '235px',
                                textAlign: 'center',
                              }}
                            >
                              <Icon type="pushpin" />{' '}
                              <LangContext.Consumer>
                                {i18n => i18n.p.pinDoesNotExistInSystem}
                              </LangContext.Consumer>
                            </div>
                          )}

                        {this.state.selectTools != 'pinDoesNotExistInSystem' &&
                          this.state.selectTools != 'directionRoute' &&
                          this.state.isMenuMapToolsCLick !== 'updateRoute' && (
                            <Button
                              size="default"
                              style={{
                                color:
                                  this.state.geoFene.length > 2
                                    ? '#172B4D'
                                    : 'gray',
                                height: '40px',
                              }}
                              onClick={() => {
                                this.handlePrevious(this.state.previousPolyline)
                              }}
                              disabled={
                                this.state.geoFene.length > 2 ? false : true
                              }
                            >
                              <Icon type="undo" />{' '}
                              <LangContext.Consumer>
                                {i18n => i18n.p.previous}
                              </LangContext.Consumer>
                            </Button>
                          )}
                      </ButtonGroup>
                    </div>
                  )}

                  <div
                    style={{
                      position: 'absolute',
                      marginTop: '4px',
                      top: '110px',
                      right: '0px',
                      zIndex: '12',
                    }}
                  >
                    {this.state.isMenuMapToolsCLick === 'findArea' && (
                      <>
                        <Button
                          style={{ marginRight: '5px', width: '115px' }}
                          //   onClick={this.handleSavePolygon}
                          onClick={this.openModalConfirmPolygon}
                          type="primary"
                          disabled={
                            this.state.geoFene.length > 4 ? false : true
                          }
                        >
                          <LangContext.Consumer>
                            {i18n => i18n.s.save}
                          </LangContext.Consumer>
                        </Button>
                        <Button
                          style={{ marginRight: '5px', width: '115px' }}
                          onClick={() => {
                            this.handleCancelDrawPolygon()
                            this.loadData()
                          }}
                        >
                          <LangContext.Consumer>
                            {i18n => i18n.c.cancel}
                          </LangContext.Consumer>
                        </Button>
                      </>
                    )}

                    {this.state.isMenuMapToolsCLick == 'updateRoute' && (
                      <>
                        <Button
                          style={{ marginRight: '5px', width: '115px' }}
                          //   onClick={this.handleSavePolygon}
                          onClick={() => {
                            this.openModalConfirmPolygon()
                          }}
                          type="primary"
                          disabled={
                            this.state.newGeoFene.length > 4 ? false : true
                          }
                        >
                          <LangContext.Consumer>
                            {i18n => i18n.s.save}
                          </LangContext.Consumer>
                        </Button>
                        <Button
                          style={{ marginRight: '5px', width: '115px' }}
                          onClick={this.handleCancelEditPolygon}
                        >
                          <LangContext.Consumer>
                            {i18n => i18n.c.cancel}
                          </LangContext.Consumer>
                        </Button>
                      </>
                    )}
                  </div>
                  <div
                    id="map"
                    style={{
                      width: '100%',
                      height: `${window.innerHeight - 90}px`,
                    }}
                  ></div>
                </Col>
              </Spin>
            </Row>
          </SmartDispatchLayout>
        </Spin>
        <ModalConfirmPolygon
          showModal={this.state.showComfirmSavePolygon}
          onClose={this.onCloseModalComfirmpolygon}
          selectTools={this.state.selectTools}
          handleSelectTool={this.handleSelectTool}
          onChangeName={this.onChangeNameRoute}
          nameRoute={this.state.nameRoute}
          remark={this.state.getNote}
          handleRemark={this.onChangeRemark}
          handleSavePolygon={this.handleSavePolygon}
          handleUpdatePolygon={this.handleUpdatePolygon}
          isMenuMapToolsCLick={this.state.isMenuMapToolsCLick}
          editValue={this.state.editValue}
        />
        <ModalEditDeleteRoute
          showModal={this.state.showModalEditDeleteRoute}
          onClose={this.onCLoseModalEditDeleteRoute}
          objRoute={this.state.getNote}
          deletelocation={this.deletelocation}
          editlocation={this.editlocation}
        />
        <ListNearestModal
          showModal={this.state.showListNearestModal}
          onClose={this.onCloseNearestModal}
          chooseRoute={this.drawRouteNearBylocation}
          nearByLocationList={this.state.nearByLocationList}
        />
        <Notification
          showModal={this.state.showNotification}
          onClose={this.onCloseNotification}
          infoSearch={this.state.infoSearch}
        />
      </AuthorizeComponent>
    )
  }
}

export default connect(
  ({ SmartDispatching, auth, auth: { profile }, ui: { language } }) => ({
    auth,
    profile,
    SmartDispatching,
    language,
  }),
  {
    updateSmartDispatching: updateSmartDispatching.request,
    createSmartDispatching: createSmartDispatching.request,
    getNearByLocationSmartDispatching:
      getNearByLocationSmartDispatching.request,
  },
)(Index)
